import ComplianceStatusBadge from '../../ReturnIntakesScanner/ScannedItemCard/ComplianceStatusBadge';
import RecipientDetails from '../../ReturnIntakesScanner/ScannedItemCard/RecipientDetails';
import CardIdentifier from '../../ReturnIntakesScanner/ScannedItemCard/CardIdentifier';
import { ShippingWithReturnIntakeSummaryDto } from '../../../models';
import {
  COMPLIANCE_STATUS_CLASSES,
  DEFAULT_STATUS_CLASS,
} from '../../../config/statusChip';
import { appUrl } from '@/utils/appUrl';

interface SummaryItemCardProps {
  shipping: ShippingWithReturnIntakeSummaryDto;
  index: number;
}

const SummaryItemCard = ({ shipping, index }: SummaryItemCardProps) => {
  const complianceClasses = shipping.complianceName
    ? COMPLIANCE_STATUS_CLASSES[shipping.complianceName] || DEFAULT_STATUS_CLASS
    : DEFAULT_STATUS_CLASS;

  const addr = shipping.destinationAddress;
  const formattedAddress = addr
    ? `${addr.streetName || ''} ${addr.doorNumber || ''} ${addr.apartmentNumber ? `Apt ${addr.apartmentNumber}` : ''}`.trim()
    : 'Sin dirección';

  const openDetails = () => {
    window.open(appUrl(`/business/shipping/${shipping.shippingNumber}`), '_blank');
  };

  return (
    <div 
      className='flex flex-col md:flex-row md:items-center gap-6 p-6 bg-white rounded-2xl border border-gray-100'
    >
      <CardIdentifier
        index={index + 1}
        shippingNumber={Number(shipping.shippingNumber)}
        commerceShippingNumber={shipping.commerceShippingNumber}
        commerceName={shipping.commerceName}
        onOpenDetails={openDetails}
      />

      <RecipientDetails 
        recipient={shipping.recipient} 
        address={formattedAddress} 
      />
      
      <div className='flex items-center gap-6'>
        <div className='flex items-center gap-4'>
          <div className='flex flex-wrap items-center justify-end gap-2'>
            <span className='text-[13px] font-semibold px-2.5 py-1 rounded-md w-fit bg-orange-50 text-orange-700'>
              Estado actual: {shipping.shippingStatusCommercialName || shipping.shippingStatus || 'S/D'}
            </span>
            <ComplianceStatusBadge
              commercialName={shipping.complianceCommercialName}
              classes={complianceClasses}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryItemCard;
